import { FieldView } from '../../FieldEditor';
import { SalvDataTag } from '@salvapp/ui-components';
import InternalLink from '../../../common/InternalLink';
import {
  InternalApiEntityType,
  InternalApiScenarioContentTestResultInformation,
  InternalApiScenarioEntityType,
} from '../../../api-internal';
import React from 'react';
import { useQuerySegments } from '../../../screening/configure/segments/segmentActions';
import { SegmentLogicType } from '../../segments/SegmentsEditor';

interface Props {
  type: SegmentLogicType;
  entityType: InternalApiScenarioEntityType;
  testResult: InternalApiScenarioContentTestResultInformation;
}

const TestRunTriggeringSegments = ({ type, entityType, testResult }: Props) => {
  const { data: segments } = useQuerySegments();

  const headerPrefix = type === 'INCLUDED' ? 'Included ' : 'Excluded ';
  const scenarioSegmentCodes = type === 'INCLUDED' ? testResult.testSegments : testResult.testExcludedSegments;

  const personSegments =
    segments?.filter(
      (segment) => segment.entityType === InternalApiEntityType.PERSON && scenarioSegmentCodes?.includes(segment.code)
    ) || [];

  const transactionSegments =
    segments?.filter(
      (segment) =>
        segment.entityType === InternalApiEntityType.TRANSACTION && scenarioSegmentCodes?.includes(segment.code)
    ) || [];

  return (
    <>
      <FieldView
        label={headerPrefix + 'Person Segments'}
        value={
          personSegments.length
            ? personSegments.map((segment) => (
                <SalvDataTag
                  className='m-t-8'
                  key={segment.id}
                  value={<InternalLink title={segment.name} link={`/segments/${segment.code}`} />}
                />
              ))
            : '-'
        }
      />

      {entityType === InternalApiScenarioEntityType.TRANSACTION && (
        <FieldView
          label={headerPrefix + 'Transaction Segments'}
          value={
            transactionSegments.length
              ? transactionSegments.map((segment) => (
                  <SalvDataTag
                    className='m-t-8'
                    key={segment.id}
                    value={<InternalLink title={segment.name} link={`/segments/${segment.code}`} />}
                  />
                ))
              : '-'
          }
        />
      )}
    </>
  );
};

export default TestRunTriggeringSegments;
